import type { VariantProps } from 'class-variance-authority';

import { cnva } from '@/app/utils/cnva';

export const ImageStyled = cnva('absolute inset-0 size-full object-cover', {
  variants: {
    layout: {
      fill: 'max-h-full min-h-full min-w-full',
      ratio: '',
    },
    loadedEffect: {
      fade: 'transition-image opacity-0',
      none: '',
    },
    hoverEffect: {
      zoom: 'transition-image cursor-pointer hover:scale-105',
    },
    objectFit: {
      contain: 'object-contain',
      cover: 'object-cover',
    },
    objectPosition: {
      top: 'object-top',
      left: 'object-left',
      right: 'object-right',
      bottom: 'object-bottom',
    },
    isLoaded: {
      true: 'is-loaded',
    },
    isGroupHover: {
      true: '',
    },
  },
  compoundVariants: [
    {
      loadedEffect: 'fade',
      isLoaded: true,
      className: 'opacity-100',
    },
    {
      isGroupHover: true,
      hoverEffect: 'zoom',
      className: 'group-hover:scale-105',
    },
  ],
  defaultVariants: {
    loadedEffect: 'fade',
    layout: 'ratio',
  },
});

export const PictureStyled = cnva('relative block overflow-hidden', {
  variants: {
    layout: {
      fill: 'absolute inset-0',
      ratio: 'w-full',
    },
    placeholder: {
      shimmer: 'loading-shimmer-light',
      'dark-shimmer': 'loading-shimmer-dark',
    },
    showPlaceholder: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      placeholder: ['shimmer', 'dark-shimmer'],
      className:
        'loading-shimmer after:ease-bounce loading-shimmer-loading after:transition-opacity after:duration-500',
    },
    {
      placeholder: ['shimmer', 'dark-shimmer'],
      showPlaceholder: false,
      className: 'after:pause-animation before:opacity-0 after:opacity-0',
    },
  ],
  defaultVariants: {
    layout: 'ratio',
    showPlaceholder: false,
  },
});

export type ImageStyledType = VariantProps<typeof ImageStyled>;
export type PictureStyledType = VariantProps<typeof PictureStyled>;
